import { Map, ObjectManager, YMaps } from "@pbe/react-yandex-maps";
import React, { memo, useMemo, useRef } from "react";
import MapControls from "../UI/MapControls/MapControls";
import useMapControl from "./hooks/useMapControl";
import PlacemarkIcon from "./icons/pin.svg";

function PickupMap({ points, onPlacemarkClick, city }) {
  const mapRef = useRef(null);
  const { handleLocateMe, handleZoomIn, handleZoomOut } = useMapControl(mapRef);
  const features = points.map((pt) => ({
    type: "Feature",
    id: pt.id,
    geometry: {
      type: "Point",
      coordinates: [pt.latitude, pt.longitude],
    },
    properties: {
      hintContent: pt.address,
    },
  }));

  const center = useMemo(() => {
      if (!city?.data?.geo_lat || !city?.data?.geo_lon) return [55.75, 37.62];
      return [parseFloat(city.data.geo_lat), parseFloat(city.data.geo_lon)];
    }, [city]);

  return (
    <YMaps>
      <div
        className="shipping-map"
        style={{ position: "relative", width: "100%", height: "100%" }}
      >
        <Map
          state={{ center, zoom: 10, controls: [] }}
          instanceRef={mapRef}
          style={{ width: "100%", height: "100%" }}
        >
          <ObjectManager
            options={{
              clusterize: true,
              gridSize: 64,
              clusterDisableClickZoom: false,
              minClusterSize: 4,
            }}
            objects={{
              iconLayout: "default#image",
              iconImageHref: PlacemarkIcon,
              iconImageSize: [40, 40],
              iconImageOffset: [-20, -20],
            }}
            clusters={{
              preset: "islands#blackClusterIcons",
            }}
            features={features}
            modules={[
              "objectManager.addon.objectsHint",
              "objectManager.addon.clustersBalloon",
            ]}
            instanceRef={(ref) => {
              if (ref) {
                ref.objects.events.add("click", (e) => {
                  const objectId = e.get("objectId");
                  const pt = points.find((p) => p.id === objectId);
                  if (pt) {
                    mapRef.current.setCenter([pt.latitude, pt.longitude], 14, {
                      duration: 200,
                    });
                    onPlacemarkClick(pt.id);
                  }
                });
              }
            }}
          />
        </Map>

        <MapControls
          className="shipping-map__controls"
          onLocate={handleLocateMe}
          onZoomIn={handleZoomIn}
          onZoomOut={handleZoomOut}
        />
      </div>
    </YMaps>
  );
}

export default memo(PickupMap);
